import { IonCol, IonGrid, IonRow, IonIcon } from "@ionic/react"
import { SimilarLoadModel } from "../../../models/home/SimilarLoads.model";
import { logEvent } from "../../../utils/Analytics";
import { IONICWrapper, LPEFeedbackWrapper } from "../../../utils/common";
import { DEFAULT_BUTTON_COLOR, ICON_PATH } from "../../../utils/constants";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import React, { useState } from "react"
import { useEffect } from "react";
import { LoadSimilar } from "./LoadSimilar";
import "./similar-loads-list.scss";
import { isDispatcherRole } from "../../../utils/roleUtil/RoleUtil";
const LoadSimilarContainer = (props: any) => {

    const [isLoadVisible, setloadsVisible] = useState(false);
    const [loader, setLoader] = useState(false);
    const hasSimilarLoads: boolean = typeof props.loads[0] === "object";
    const _SimilarLoadModel: SimilarLoadModel = new SimilarLoadModel();
    const toggle = () => {
        if (!hasSimilarLoads) {
            isLoadVisible ? props.setShowSimilarLoadId("") : props.setShowSimilarLoadId(props.primaryLoad)
            setLoader(true);
            _SimilarLoadModel.input = props.loads;
            props.fetchSimilarLoads({ query: _SimilarLoadModel.getRequestPayload(), loads: props.loads, primaryLoadId: props.primaryLoad }, () => {
                setLoader(false);
            })
        }
        setloadsVisible(!isLoadVisible)

        !isLoadVisible && LPEFeedbackWrapper.log(EVENT.UE_RECOMMENDED_SIMILAR_LOADS, {
            screen: SCREEN.RECOMMENDED_SIMILAR_LOAD,
            loadId: props.primaryLoad,
            lead: props.module,
            rank: props.rank,
            resultId: props.resultId
        });
        !isLoadVisible && logEvent(EVENT.UE_RECOMMENDED_SIMILAR_LOADS, {
            screen: SCREEN.RECOMMENDED_SIMILAR_LOAD,
            loadId: props.primaryLoad,
            lead: props.module,
            rank: props.rank,
            resultId: props.resultId
        });

    }
    useEffect(() => {
        if (isLoadVisible) { setloadsVisible(props.primaryLoad === props.showSimilarLoadId) }
    }, [props.showSimilarLoadId])

    const similarLoadsTextColor = IONICWrapper.details.getKeyValuePairs("similarloads_color");

    return (
        <>{!hasSimilarLoads && loader && <div className="similar-loads-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>}
            <IonGrid className='similar-loads-container'>
                <IonCol className={`similar-loads-web${hasSimilarLoads && isLoadVisible ? ' show-loads-web' : ' hide-loads-web'}`}>
                    {hasSimilarLoads && isLoadVisible && <LoadSimilar {...props} />}
                </IonCol>
                <IonRow className='child-footer'>
                    <IonRow className={"titlecircle-container"} onClick={toggle}>
                        <IonRow className='footer-title' style={{color: isDispatcherRole() ? `${similarLoadsTextColor}` : DEFAULT_BUTTON_COLOR}}>{(isLoadVisible) ? "Hide similar loads" : `Show ${props.loads.length} similar loads`}</IonRow>
                        <IonRow className={isLoadVisible ? 'footer-circle_load_visible' : 'footer-circle'}>
                            <IonIcon className={"ionIconBtn"} style={{color: isDispatcherRole() ? `${similarLoadsTextColor}` : DEFAULT_BUTTON_COLOR}} src={isLoadVisible ? ICON_PATH.minus : ICON_PATH.plus} /></IonRow>
                    </IonRow>
                    <IonCol className='footer-mark' />
                </IonRow>
            </IonGrid>
        </>
    );
}

export default React.memo(LoadSimilarContainer);